// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12ZM6 9H10V11H9V14H7V11H6V9ZM14 9H18V11H17V14H15V11H14V9ZM11.9998 18.9998C9.9093 18.9998 8.41829 17.1984 8.01905 15.1953L15.9805 15.1953C15.5812 17.1984 14.0902 18.9998 11.9998 18.9998Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-cry-and-laugh-filled')
export default class CryAndLaughFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cry-and-laugh-filled',
    }
  }
}
